export type CarrierType = 'shipping_line' | 'airline' | 'co_loader' | 'nvocc' | 'trucker';

export const CARRIER_TYPES: { value: CarrierType; label: string }[] = [
  { value: 'shipping_line', label: 'Shipping Line' },
  { value: 'airline', label: 'Airline' },
  { value: 'co_loader', label: 'Co-Loader' },
  { value: 'nvocc', label: 'NVOCC' },
  { value: 'trucker', label: 'Trucker' },
];

export interface Carrier {
  id: number;
  code: string;              // Carrier code (e.g., MAERSK, COSCO)
  name: string;              // Full name
  carrierType?: string;      // shipping_line, airline, co_loader, nvocc, trucker
  modes: string[] | null;    // ['FCL', 'LCL', 'Air', 'RORO']
  regions: string[] | null;  // Geographic regions served
  notes?: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt?: Date;
}

export interface CreateCarrierDto {
  code: string;
  name: string;
  carrierType?: string;
  modes?: string[];
  regions?: string[];
  notes?: string;
  isActive: boolean;
}

export interface UpdateCarrierDto {
  code?: string;
  name?: string;
  carrierType?: string;
  modes?: string[];
  regions?: string[];
  notes?: string;
  isActive?: boolean;
}
